import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { Button } from '@/components/ui/Button';
import { Card } from '@/components/ui/Card';
import { Input } from '@/components/ui/Input';
import { useSendCode } from '@/hooks/useAuth';
import { extractApiError } from '@/api/client';

export function LoginPage() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [phone, setPhone] = useState('+7');
  const [error, setError] = useState<string | null>(null);
  const sendCode = useSendCode();

  const onSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError(null);
    try {
      await sendCode.mutateAsync(phone);
      navigate('/login/otp', { state: { phone } });
    } catch (err) {
      setError(extractApiError(err).message);
    }
  };

  return (
    <Card title={t('auth.login_title')}>
      <form onSubmit={onSubmit} className="space-y-4">
        <Input
          label={t('auth.phone_label')}
          type="tel"
          value={phone}
          onChange={(e) => setPhone(e.target.value)}
          placeholder="+7 (___) ___-__-__"
          autoFocus
          required
          error={error ?? undefined}
        />
        <Button type="submit" className="w-full" loading={sendCode.isPending}>
          {t('auth.send_code')}
        </Button>
      </form>
    </Card>
  );
}
